import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../style/staffmanagement.css";

function StaffManagement() {
  const navigate = useNavigate();

  const [staffMembers, setStaffMembers] = useState([
    { id: 1, name: "Sparsh", role: "Office Executive", phone: "9876543210" },
    { id: 2, name: "Tanmay", role: "Field Executive", phone: "9123456789" }
  ]);

  const [newStaff, setNewStaff] = useState({ name: "", role: "", phone: "" });
  const [editingStaff, setEditingStaff] = useState(null);

  // Handle input change
  const handleChange = (e) => {
    setNewStaff({ ...newStaff, [e.target.name]: e.target.value });
  };

  // Add a staff member
  const handleAdd = () => {
    if (!newStaff.name || !newStaff.role || !newStaff.phone) return;
    setStaffMembers([...staffMembers, { id: Date.now(), ...newStaff }]);
    setNewStaff({ name: "", role: "", phone: "" });
  };

  // Edit a staff member
  const handleEdit = (staff) => {
    setEditingStaff(staff);
    setNewStaff(staff);
  };

  // Save edited staff
  const handleSaveEdit = () => {
    setStaffMembers(staffMembers.map(st => st.id === editingStaff.id ? newStaff : st));
    setNewStaff({ name: "", role: "", phone: "" });
    setEditingStaff(null);
  };

  // Delete a staff member
  const handleDelete = (id) => {
    setStaffMembers(staffMembers.filter(st => st.id !== id));
  };

  return (
    <div className="staff-management-wrapper">
      {/* Full-Width Navbar */}
      <nav className="staff-navbar">
        <div className="staff-navbar-content">
          <span className="staff-title">Staff Management</span>
          {/* <button className="back-btn" onClick={() => navigate("/")}>Back</button> */}
        </div>
      </nav>

      <div className="staff-container">
        <div className="staff-form">
          <input type="text" name="name" placeholder="Staff Name" value={newStaff.name} onChange={handleChange} />
          <input type="text" name="role" placeholder="Role" value={newStaff.role} onChange={handleChange} />
          <input type="text" name="phone" placeholder="Phone Number" value={newStaff.phone} onChange={handleChange} />

          {editingStaff ? (
            <button onClick={handleSaveEdit} className="staff-btn save-btn">Save Changes</button>
          ) : (
            <button onClick={handleAdd} className="staff-btn add-btn">Add Staff</button>
          )}
        </div>

        <div className="staff-list">
          <h3>Staff Members</h3>
          {staffMembers.length === 0 ? <p>No staff added yet.</p> : (
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Role</th>
                  <th>Phone</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {staffMembers.map((staff) => (
                  <tr key={staff.id}>
                    <td>{staff.name}</td>
                    <td>{staff.role}</td>
                    <td>{staff.phone}</td>
                    <td>
                      <button onClick={() => handleEdit(staff)} className="edit-btn">Edit</button>
                      <button onClick={() => handleDelete(staff.id)} className="delete-btn">Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
      <footer className="admin-dashboard-footer">
        <button className="admin-dashboard-nav-btn" onClick={() => navigate("/admin")}>
          Home
        </button>
        
        <button className="admin-dashboard-nav-btn" onClick={() => navigate("/resident")}>
          Resident
        </button>
        <button className="admin-dashboard-nav-btn" onClick={() => navigate("/adminreport")}>
          Reports
        </button>
      </footer>
    </div>
  );
}

export default StaffManagement;
